import streamProviderFromFetcher from 'rlink-data-connector/streams/streamProviderFromFetcher';
import cachingRequestProvider from 'rlink-data-connector/streams/cachingRequestProvider';
import warnOnce from 'rlink-debug-utils/warnOnce';

// shim for newer request stream thingy
export default function makeRequester ({
  request,
  caching,
  fetch,
  mapResponse,
}) {
  warnOnce(`Requesters are deprecated. Please use request stream providers instead. (request: ${request} for type: ${request.type.name})`);
  if (mapResponse) {
    throw new Error(`mapResponse function MUST be moved inside clientCall (request: ${request} for type: ${request.type})`);
  }
  let streamProvider = streamProviderFromFetcher(fetch);
  if (caching) {
    streamProvider = cachingRequestProvider(caching, streamProvider);
  }
  return streamProvider;
}





// WEBPACK FOOTER //
// ./lib/rlink-data-connector/makeRequester.js